import { Injectable, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
  providedIn: 'root',
})
export class EventEmitterService {
  invokeParentComponentReload = new EventEmitter();
  subsVar: Subscription;

  private userSignInSubject = new Subject<void>();
  userSignIn$ = this.userSignInSubject.asObservable();

  constructor() {}

  onComponentReloadClick() {
    this.invokeParentComponentReload.emit();
  }

  //Emits a signal when new user is signed in
  //This will force the UserRolesService to refresh the user roles
  emitUserSignInEvent() {
    this.userSignInSubject.next();
  }
}
